<template>
    <div class="container-fluid bg bg-pj-jc m-0 p-0 animated fadeIn slow">
        <div class="lime-bar-footer fixed-bottom"></div>
        <div class="container px-0">
            <div class="d-flex flex-column" style="height: 99vh;">
                <div class="mr-auto mt-3 ml-3">
                    <logo></logo>
                </div>
                <div class="align-self-center d-flex flex-column my-auto ml--5">
                    <div class="font-italic font-weight-bold text-uppercase font-italic title font-xl z1 align-self-center">
                        who do you think
                        you are?
                    </div>
                    <div class="lime-bar-diag ml-5 mt--4">
                        <img src="../assets/img/Asset_3.png" alt="" class="ml-5 pl-5">
                    </div>
                    <div class="text-uppercase font-italic sub-title font-xs z1 mt--3">
                        as a matter of fact...
                    </div>
                    <b-form @submit.prevent="onSubmit">
                        <div class="form mt-4">
                            <div class="row m-0 p-0">
                                <div class="col-5 m-0 p-0 pt-2 text-right">
                                    <span class="label font-italic text-uppercase">name : </span>
                                </div>
                                <div class="col-7 m-0 p-0 text-left">
                                    <input v-model="userDetails.name"
                                           type="text"
                                           autocomplete="name">
                                </div>
                            </div>
                            <div class="row m-0 p-0">
                                <div class="col-5 m-0 p-0 pt-2 text-right"><span
                                        class="label font-italic text-uppercase">country : </span></div>
                                <div class="col-7 m-0 p-0 text-left">
                                    <input v-model="userDetails.country"
                                           type="text"
                                           autocomplete="country">
                                </div>
                            </div>
                            <div class="row m-0 p-0">
                                <div class="col-5 m-0 p-0 pt-2 text-right">
                                    <span class="label font-italic text-uppercase">email : </span>
                                </div>
                                <div class="col-7 m-0 p-0 text-left">
                                    <input v-model="userDetails.email"
                                           type="email"
                                           autocomplete="email">
                                </div>
                            </div>
                            <div class="row m-0 p-0">
                                <div class="col-5 m-0 p-0 pt-2 text-right">
                                    <span class="label font-italic text-uppercase">password : </span>
                                </div>
                                <div class="col-7 m-0 p-0 text-left">
                                    <input v-model="userDetails.password"
                                           :type="type"
                                           autocomplete="password"
                                           @keyup.enter="register()">
                                    <img v-show="!showPassword" @click="showPassword = !showPassword"
                                         class="eye ml-2 pointer mt--2"
                                         src="../assets/img/eye-slash-light.svg" alt="">
                                    <img v-show="showPassword" @click="showPassword = !showPassword"
                                         class="eye ml-2 pointer mt--2"
                                         src="../assets/img/eye-light.svg" alt=""></div>
                            </div>
                            <div class="text-right text-uppercase font-italic font-sm sub-title mt-3 pointer"
                                 @click="register()">
                                request
                            </div>
                        </div>
                    </b-form>

                </div>
            </div>
        </div>
    </div>

</template>

<script>
    // @ is an alias to /src
    import logo from '@/components/RufusLogo'
    import firebase from 'firebase'

    export default {
        name      : 'Register',
        components: {
            logo
        },
        data () {
            return {
                userDetails : {
                    email   : '',
                    password: '',
                    country : null,
                    name    : null,
                },
                showPassword: false,
                type        : 'password',
                redirect    : false,
                countryList : [
                    'Afghanistan',
                    'Albania',
                    'Algeria',
                    'American Samoa',
                    'Andorra',
                    'Angola',
                    'Anguilla',
                    'Antigua and Barbuda',
                    'Argentina',
                    'Armenia',
                    'Aruba',
                    'Australia',
                    'Austria',
                    'Azerbaijan',
                    'The Bahamas',
                    'Bahrain',
                    'Bangladesh',
                    'Barbados',
                    'Belarus',
                    'Belgium',
                    'Belize',
                    'Benin',
                    'Bermuda',
                    'Bhutan',
                    'Bolivia',
                    'Bosnia and Herzegovina',
                    'Botswana',
                    'Brazil',
                    'Brunei',
                    'Bulgaria',
                    'Burkina Faso',
                    'Burundi',
                    'Cambodia',
                    'Cameroon',
                    'Canada',
                    'Cape Verde',
                    'Cayman Islands',
                    'Central African Republic',
                    'Chad',
                    'Chile',
                    'People s Republic of China',
                    'Republic of China',
                    'Christmas Island',
                    'Cocos(Keeling) Islands',
                    'Colombia',
                    'Comoros',
                    'Congo',
                    'Cook Islands',
                    'Costa Rica',
                    'Cote d\'Ivoire',
                    'Croatia',
                    'Cuba',
                    'Cyprus',
                    'Czech Republic',
                    'Denmark',
                    'Djibouti',
                    'Dominica',
                    'Dominican Republic',
                    'Ecuador',
                    'Egypt',
                    'El Salvador',
                    'Equatorial Guinea',
                    'Eritrea',
                    'Estonia',
                    'Ethiopia',
                    'Falkland Islands',
                    'Faroe Islands',
                    'Fiji',
                    'Finland',
                    'France',
                    'French Polynesia',
                    'Gabon',
                    'The Gambia',
                    'Georgia',
                    'Germany',
                    'Ghana',
                    'Gibraltar',
                    'Greece',
                    'Greenland',
                    'Grenada',
                    'Guadeloupe',
                    'Guam',
                    'Guatemala',
                    'Guernsey',
                    'Guinea',
                    'Guinea - Bissau',
                    'Guyana',
                    'Haiti',
                    'Honduras',
                    'Hong Kong',
                    'Hungary',
                    'Iceland',
                    'India',
                    'Indonesia',
                    'Iran',
                    'Iraq',
                    'Ireland',
                    'Israel',
                    'Italy',
                    'Jamaica',
                    'Japan',
                    'Jersey',
                    'Jordan',
                    'Kazakhstan',
                    'Kenya',
                    'Kiribati',
                    'North Korea',
                    'South Korea',
                    'Kosovo',
                    'Kuwait',
                    'Kyrgyzstan',
                    'Laos',
                    'Latvia',
                    'Lebanon',
                    'Lesotho',
                    'Liberia',
                    'Libya',
                    'Liechtenstein',
                    'Lithuania',
                    'Luxembourg',
                    'Macau',
                    'Macedonia',
                    'Madagascar',
                    'Malawi',
                    'Malaysia',
                    'Maldives',
                    'Mali',
                    'Malta',
                    'Marshall Islands',
                    'Martinique',
                    'Mauritania',
                    'Mauritius',
                    'Mayotte',
                    'Mexico',
                    'Micronesia',
                    'Moldova',
                    'Monaco',
                    'Mongolia',
                    'Montenegro',
                    'Montserrat',
                    'Morocco',
                    'Mozambique',
                    'Myanmar',
                    'Nagorno - Karabakh',
                    'Namibia',
                    'Nauru',
                    'Nepal',
                    'Netherlands',
                    'Netherlands Antilles',
                    'New Caledonia',
                    'New Zealand',
                    'Nicaragua',
                    'Niger',
                    'Nigeria',
                    'Niue',
                    'Norfolk Island',
                    'Turkish Republic of Northern Cyprus',
                    'Northern Mariana',
                    'Norway',
                    'Oman',
                    'Pakistan',
                    'Palau',
                    'Palestine',
                    'Panama',
                    'Papua New Guinea',
                    'Paraguay',
                    'Peru',
                    'Philippines',
                    'Pitcairn Islands',
                    'Poland',
                    'Portugal',
                    'Puerto Rico',
                    'Qatar',
                    'Romania',
                    'Russia',
                    'Rwanda',
                    'Saint Barthelemy',
                    'Saint Helena',
                    'Saint Kitts and Nevis',
                    'Saint Lucia',
                    'Saint Martin',
                    'Saint Pierre and Miquelon',
                    'Saint Vincent and the Grenadines',
                    'Samoa',
                    'San Marino',
                    'Sao Tome and Principe',
                    'Saudi Arabia',
                    'Senegal',
                    'Serbia',
                    'Seychelles',
                    'Sierra Leone',
                    'Singapore',
                    'Slovakia',
                    'Slovenia',
                    'Solomon Islands',
                    'Somalia',
                    'Somaliland',
                    'South Africa',
                    'South Ossetia',
                    'Spain',
                    'Sri Lanka',
                    'Sudan',
                    'Suriname',
                    'Svalbard',
                    'Swaziland',
                    'Sweden',
                    'Switzerland',
                    'Syria',
                    'Taiwan',
                    'Tajikistan',
                    'Tanzania',
                    'Thailand',
                    'Timor - Leste',
                    'Togo',
                    'Tokelau',
                    'Tonga',
                    'Transnistria Pridnestrovie',
                    'Trinidad and Tobago',
                    'Tristan da Cunha',
                    'Tunisia',
                    'Turkey',
                    'Turkmenistan',
                    'Turks and Caicos Islands',
                    'Tuvalu',
                    'Uganda',
                    'Ukraine',
                    'United Arab Emirates',
                    'United Kingdom',
                    'United States',
                    'Uruguay',
                    'Uzbekistan',
                    'Vanuatu',
                    'Vatican City',
                    'Venezuela',
                    'Vietnam',
                    'British Virgin Islands',
                    'Isle of Man',
                    'US Virgin Islands',
                    'Wallis and Futuna',
                    'Western Sahara',
                    'Yemen',
                    'Zambia',
                    'Zimbabwe'
                ]
            }
        },
        computed  : {
            userRole () {
                return this.$store.getters.getUserRole
            }
        },
        methods   : {
            register () {
                let userDetails = this.userDetails
                let self        = this

                this.$store.dispatch('register', userDetails)
                    .then(() => {
                        self.$router.push({path: '/success'})
                    })
                    .catch((error) => {
                        console.log(error);
                        // self.$router.push({path: '/'})
                    })
            }
        },
        watch     : {
            showPassword (val) {
                val ? this.type = 'text' : this.type = 'password'
            }
        },
        created () {
            let self = this

            firebase.auth().onAuthStateChanged(function (user) {
                if (user) {
                    // User is signed in.
                    var displayName   = user.displayName;
                    var email         = user.email;
                    var emailVerified = user.emailVerified;
                    var photoURL      = user.photoURL;
                    var isAnonymous   = user.isAnonymous;
                    var uid           = user.uid;
                    var providerData  = user.providerData;
                    // console.log('coming from created' + JSON.stringify(user));
                    // self.redirect = true
                    self.$router.push({path: '/success'})
                    // ...
                } else {
                    // User is signed out.
                    // ...
                }
            });
        }
    }
</script>

<style scoped lang="scss">
    @import '../assets/css/_vars.scss';

    .sub-title {
        margin-left: 350px;
    }

    input {
        border-width: 0 0 1px;
        border-color: #666666;
        transform: translateY(-5px);
        margin-top: 8px;
        background: transparent;
        min-width: 260px;
    }

    .label {
        letter-spacing: 5px;
        color: #666666;
        transform: translateY(5px);
    }

    .eye {
        height: 16px;
        width: auto;
        color: #666666;
    }

    .bg-pj-jc {
        background-image: url(../assets/img/PJ-JC.png);
    }
</style>
